import type { Change } from "diff";

export function DiffSpan({ change }: { change: Change }) {
  if (change.added) {
    return (
      <span className="bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400">
        {change.value}
      </span>
    );
  }
  if (change.removed) {
    return (
      <span className="bg-red-100 text-red-800 line-through dark:bg-red-900/30 dark:text-red-400">
        {change.value}
      </span>
    );
  }
  return <span>{change.value}</span>;
}
